import * as THREE from 'three/webgpu';
import type { SketchGroup } from '../../../../mesh/sketch/SketchGroup';
import { SketchParabolaObject } from '../../../../mesh/sketch/SketchParabolaObject';
import type { ProjectionResult, WorldCoordinate } from '../../model/ProjectionResult';
import type {
	ParabolaReferenceBuilderInput,
} from '../../../../../types/reference/sketch-entity-reference/ParabolaReferenceBuilder';

export type {
	ParabolaReferenceBuilderInput,
} from '../../../../../types/reference/sketch-entity-reference/ParabolaReferenceBuilder';

/**
 * 抛物线引用构建器。
 * 说明：
 * 1. Convert Entities 创建新的目标抛物线对象；
 * 2. 抛物线语义由焦点、顶点和起终参数完整表达；
 * 3. 控制点由 `SketchParabolaObject` 创建，factory 负责把这些控制点挂入目标草图。
 */
export class ParabolaReferenceBuilder {
	/**
	 * 构建抛物线对象。
	 *
	 * @param input 构建输入。
	 * @returns 已完成几何初始化的抛物线对象。
	 */
	public build(input: ParabolaReferenceBuilderInput): SketchParabolaObject {
		return new SketchParabolaObject({
			referencePlane: input.targetSketch.referencePlane,
			definition: {
				focalWorld: toVector3(input.geometryPayload.focalWorld),
				apexWorld: toVector3(input.geometryPayload.apexWorld),
				startParameter: input.geometryPayload.startParameter,
				endParameter: input.geometryPayload.endParameter,
				segments: input.geometryPayload.segments,
			},
		});
	}
}

/**
 * 将世界坐标元组转为向量。
 *
 * @param position 世界坐标元组。
 * @returns 三维向量。
 */
function toVector3(position: WorldCoordinate): THREE.Vector3 {
	return new THREE.Vector3(...position);
}
